import React, { FC } from 'react'
import { motion } from 'framer-motion'
import WEB1 from '../../../../app/assets/images/projectImage/moodyMonthImage/web-1.png'
import WEB2 from '../../../../app/assets/images/projectImage/moodyMonthImage/web-2.png'
import WEB3 from '../../../../app/assets/images/projectImage/moodyMonthImage/web-3.png'
import WEB4 from '../../../../app/assets/images/projectImage/moodyMonthImage/web-4.webp'
interface MoodyMonthOverviewProps {
    moodyProjectData: any;
}

const MoodyMonthOverview: FC<MoodyMonthOverviewProps> = ({ moodyProjectData }) => {
    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6 }
        }
    }

    const slideIn = {
        hidden: { opacity: 0, x: -50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.7 }
        }
    }

    const slideInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.7 }
        }
    }

    const staggerContainer = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.3
            }
        }
    }
    return (
        <div>
            <motion.div
                className='flex flex-col md:flex-row items-center justify-center px-4 md:px-16 gap-8 md:gap-32'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
            >
                <motion.div variants={slideIn} className="w-full md:w-auto">
                    <img src={WEB1} className='w-full' />
                </motion.div>
                <motion.div variants={slideInRight} className="w-full md:w-auto mt-6 md:mt-0 px-4 md:px-0">
                    <div className='text-2xl md:text-3xl font-bold text-center md:text-left'>Overview</div>
                    <div className='text-[#e0e0e0] pt-2 text-base md:text-lg text-center md:text-left'>Moody Month operates as an independent center for
                        pain treatment, aiding patients with complicated cases
                        that do not respond to usual treatments. The care is delivered
                        by pain specialists and nurses. They are based in
                        Velsen-Noord, the Netherlands.</div>
                </motion.div>
            </motion.div>

            <motion.div
                className='mt-12 relative'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeIn}
            >
                <div className=''>
                    <div className='px-4 md:px-32 text-2xl md:text-3xl font-bold pb-2 text-center md:text-left'>Objectives</div>
                    <div className='flex flex-col md:flex-row items-center md:items-start justify-start bg-[#42c7bc] relative'>
                        <motion.div
                            className='px-4 md:pl-32 text-[#d9f4f2] pt-2 pb-4 md:pb-0 text-base md:text-lg w-full md:w-auto z-10 text-center md:text-left'
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            Click-to-Select Pain Areas: Offer an easy tool where users can click on various body parts of a picture to find
                            related pain treatments without needing to know
                            medical jargon.
                        </motion.div>
                        <motion.div
                            className='relative h-auto md:h-[18rem] w-full z-10'
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <img src={WEB2} className='w-auto md:absolute md:-top-16 max-h-[28rem]' />
                        </motion.div>
                        <div className='hidden md:block absolute right-0 bg-moodyColor z-0 w-[15%] h-full'></div>
                    </div>
                </div>
            </motion.div>
            <motion.div
                className='mt-16 md:mt-36 relative'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeIn}
            >
                <div className='pb-16 md:pb-44 md:pl-[6%]'>
                    <div className='px-4 md:px-32 text-2xl md:text-3xl font-bold pb-2 relative md:left-[9%] text-center md:text-left'>Solutions</div>
                    <div className='flex flex-col md:flex-row-reverse items-center md:items-start justify-start bg-[#2cab9a] relative text-center md:text-left'>
                        <motion.div
                            className='w-full md:w-[80%] text-[#d9f4f2] pl-4 p-4 md:pt-2 text-base md:text-lg md:pr-[10%] text-center md:text-left'
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                            viewport={{ once: true }}
                        >SATTVA TECH joined forces to
                            develop the Excellent Care Clinics website. We used tools
                            like WordPress and Elementor, along with different plugins,
                            to make the site perfect for Excellent Care Clinics. We
                            incorporated a 3D model to enhance interactivity. Our
                            coding skills enabled us to adapt the site to the specific
                            requirements of Excellent Care Clinics, ensuring a
                            personalized and impactful online presence.
                        </motion.div>
                        <motion.div
                            className='relative h-auto md:h-[18rem] w-full z-10'
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <img src={WEB3} className='w-auto md:absolute md:-top-16 max-h-[28rem]' />
                        </motion.div>
                        <div className='hidden md:block absolute left-0 bg-moodyColor z-0 w-[15%] h-full'></div>
                    </div>
                </div>
            </motion.div>

            <div>
                <motion.div
                    className='bg-white z-10 px-4 md:px-16'
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <img src={WEB4} className='z-10 relative -bottom-6 md:-bottom-10 w-full' />
                </motion.div>
                <motion.div
                    className='bg-moodyColor pt-12 md:pt-20 text-center flex flex-col items-center justify-center gap-4 pb-12 md:pb-16 px-4'
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={staggerContainer}
                >
                    <motion.div
                        className='text-2xl md:text-4xl font-bold'
                        variants={fadeIn}
                    >
                        Moody Month
                    </motion.div>
                    <motion.div
                        className='w-full md:w-[80%] lg:w-[60%] text-base md:text-lg'
                        variants={fadeIn}
                    >
                        The website is now easier to use because we divided it into sections for different pain types.
                        Visitors can easily look through each category to find the right treatments. Finding information
                        about specific pain conditions and treatments is simpler, making the site more user-friendly.
                        We aim to help people make smart choices for pain management, so we provide clear information
                        about available treatments in each section, assisting visitors in making the best decisions for themselves.
                    </motion.div>
                </motion.div>
            </div>
        </div>
    )
}

export default MoodyMonthOverview

// {/* <div className='mt-12 relative'>
//                 <div className=''>
//                     <div className='px-32 text-3xl font-bold pb-2'>Objectives</div>
//                     <div className='flex items-start justify-start bg-[#2caa99] relative'>
//                         {/* <div className='absolute left-0 bg-moodyColor z-0 w-[15%] h-full'></div> */}
//                         {/* <div className='relative h-[18rem] w-[100%] z-10'> */}
//                             <img src={WEB3} className='absolute -top-16 h-[18rem]' />
//                         {/* </div> */}
//                         <div className='text-[#d9f4f2] pt-2 text-lg '>Mukesh from SATTVA TECH joined forces to
//                             develop the Excellent Care Clinics website. We used tools
//                             like WordPress and Elementor, along with different plugins,
//                             to make the site perfect for Excellent Care Clinics. We
//                             incorporated a 3D model to enhance interactivity. Our
//                             coding skills enabled us to adapt the site to the specific
//                             requirements of Excellent Care Clinics, ensuring a
//                             personalized and impactful online presence.</div>

//                     </div>
//                 </div>
//             </div> */}